import { GetCurrentAssessmentResultsResult } from "tech-health-assessment-sdk/dist";
import { api } from "../../../../services/core-api-service";

class CurrentAssessmentResultsService {
    public async getCurrentAssessmentResults(): Promise<GetCurrentAssessmentResultsResult> {
        return api.assessments.getCurrentAssessmentResults()
    }
}

export const service = new CurrentAssessmentResultsService()